import classNames from 'classnames'
import React, { type FC } from 'react'
import styles from './StoreAvailabilityInfo.module.scss'
import { useLocalisation } from '@/tools/i18n/client'

interface Props {
  availabilityMessage: string | null
  storeHasSchedule: boolean
  isStoreClosed: boolean
}

export const StoreAvailabilityInfo: FC<Props> = ({
  availabilityMessage,
  isStoreClosed,
  storeHasSchedule,
}) => {
  const { t } = useLocalisation()

  const shouldShowScheduleMessage = storeHasSchedule && availabilityMessage
  const shouldShowFallbackSchedule = storeHasSchedule && !availabilityMessage

  return (
    <div className={classNames('pintxo-typography-caption-emphasis', styles.availability)}>
      {shouldShowScheduleMessage && (
        <div className={styles.schedule}>
          <p>{availabilityMessage}</p>
        </div>
      )}

      {shouldShowFallbackSchedule && (
        <p className={styles.scheduleText}>{t('store-wall.schedule')}</p>
      )}

      {isStoreClosed && availabilityMessage && <p>{availabilityMessage}</p>}
    </div>
  )
}
